
<h2 class="comp-title" style="margin-bottom: 25px;">Multi select</h2>

<mat-form-field appearance="fill">
  <mat-label>בחר כרטיסים</mat-label>
  <mat-select disableOptionCentering [formControl]="toppings"  panelClass="myPanelClass" class="mySelectClass" multiple>
    <mat-select-trigger >
      {{toppings.value ? toppings.value[0] : ''}}
      <span *ngIf="toppings.value?.length > 1" class="example-additional-selection">
        (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
      </span>
    </mat-select-trigger>
    <mat-option *ngFor="let topping of toppingList" [value]="topping">{{topping}}</mat-option>
  </mat-select>
</mat-form-field>

